import {Option} from "@Elements/Dropdown/types";

export const convertToOptions = (map: Record<string, string>): Option[] => {
  return Object.entries(map).map(([value, text]) => ({
    text,
    value,
  }));
}
